import { Message } from 'element-ui'
import api from '../apiConfig/api'
import store from '../store'
export default () => {
    // 获取权限
    async function getPermissions() {
        const res = await api.apiGetPermissions()
        if (res.code !== 200) {
            return Message.error(res.message)
        }
        store.dispatch('setPermissions', res.data)
    }
    if (window.localStorage.getItem('token')) {
        getPermissions()
    }
    //初始化草稿箱
    let noticeDrafs = window.localStorage.getItem('noticeDrafs');
    if (!noticeDrafs) {
        noticeDrafs = []
    } else {
        noticeDrafs = JSON.parse(noticeDrafs);
    }
    store.dispatch('setDrafs', noticeDrafs)
}


// WEBPACK FOOTER //
// ./src/common/init.js